const state = {
  loadedObjects: 0
}

const mutations = {
  INCREMENT_LOADED_OBJECTS (state) {
    state.loadedObjects++
  }
}

const actions = {
  countLoadedObjects ({ commit }) {
    commit('INCREMENT_LOADED_OBJECTS')
  }
}

const getters = {
  loadedObjects: state => state.loadedObjects
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
